<template>
  <section>
    <div v-loading="loading">
      <div class="no-data" v-if="items.length === 0">
        <b>No Data</b>
      </div>
      <b-table
          v-if="items.length > 0"
          bordered
          hover
          responsive
          :items="items"
          :fields="
          $store.state.highlightCol.firTable
            ? $store.state.newTableFields
            : fields
        "
          @head-clicked="
          commonHighLightCol(
            $event,
            fields,
            $store.state.newTableFields,
            'firTable'
          )
        "
      >
        <template #cell(title_name)="data">
          <div style="width: 150px">
            {{ data.item.title_name }}
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      title: '放映詳情',
      fields: [
        {
          key: 'title_name',
          label: 'Film Name',
          sortable: true
        },
        {
          key: 'show_time',
          label: 'Show Time',
          sortable: true
        },
        {
          key: 'duration',
          label: 'Duration',
          sortable: true
        },
        {
          key: 'house',
          label: 'House',
          sortable: true
        },
        {
          key: 'total_admissions',
          label: 'Total ADM.',
          sortable: true
        },
        {
          key: 'total_gross',
          label: 'Total B.O.',
          sortable: true
        },
      ]
    }
  },
  watch: {},
  computed: {

  },
  methods: {

  }
}
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.title {
  width: 100%;
  border-bottom: 2px solid #0e72bc;
  color: #0e72bc;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}
.sub-title {
  width: 100%;
  color: #0e72bc;
  font-size: 20px;
  font-weight: 500;
  margin: 20px 0;
}
.search {
  display: flex;
  margin: 15px 0;
}
.table-name:hover {
  text-decoration: underline;
}
.no-data {
  width: 100%;
  text-align: center;
  border: 1px solid #eee;
  padding: 20px;
}
</style>
